import apiClient from "./baseService";
import {handleAxiosError} from "./axiosErrorHandler";
import {OAuthCredentials} from "../types/domain/oauthCredentials";

export const getUserCredentials = async (userId: string): Promise<OAuthCredentials> =>
    await apiClient
        .get<OAuthCredentials>(`/users/${userId}/credentials`)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const rotateUserCredentials = async (userId: string): Promise<OAuthCredentials> =>
    await apiClient
        .post<OAuthCredentials>(`/users/${userId}/credentials/rotate`)
        .then((response) => response.data)
        .catch(handleAxiosError);
